<h2 class="title">Solicitud de Time Off</h2>

<form [formGroup]="form" class="form-container chiquito">

<!-- Tipo de time off -->
 <div class="section">
<label id="example-radio-group-label"><h4>Tipo de Time off</h4></label>
<mat-radio-group
  aria-labelledby="example-radio-group-label"
  class="example-radio-group"
  formControlName="tipodetimeoff"
  (change)="radioChange($event)">
  @for (season of TipoTimeOff; track season) {
    <mat-radio-button class="example-radio-button" [value]="season">{{season}}</mat-radio-button>
  }
</mat-radio-group>
@if(tenure_months <= 8){
<span class="footer-note">
  Tu antigüedad debe ser mínimo de 9 meses para usar vacaciones
</span>}
 </div>
 <!-- Tipo de timeoff other -->
   @if (this.tipodetimeoff == 'Other'){
  <div class="section" >
<mat-form-field appearance="fill" style="width: 90%;">
  <mat-label style="font-weight: 500;">Otro tipo de time off</mat-label>
  <input  matInput formControlName="other_timeoff">
  <!-- Optional Hint message -->
  <!-- <mat-hint>Enter a detailed description</mat-hint> -->
</mat-form-field>
  </div>
}
  <!-- VACACIONES DISPONIBLES -->
   @if (this.tipodetimeoff == 'Vacations'){
  <div class="section" >
    <h4>VACACIONES DISPONIBLES</h4>

    <div class="days-summary">
      <span>Días otorgados: {{ granted }}</span>
      <span>Días usados: {{ used }}</span>
      <span>Días disponibles: {{ granted - used }}</span>
       <span>Adelantadas: {{ vacacion_advance }}</span>

    </div>
  </div>
}

  <!-- SOLICITUD DE DÍAS -->
  <div class="section">


    <div class="row">
      <div class="col-md-4">
             <mat-form-field appearance="outline" class="form-field sucursal">
          <mat-label>Sucursal</mat-label>
          <mat-select formControlName="sucursal"  (selectionChange)="onSucursalChange($event)">
            <mat-option *ngFor="let s of sucursaleslist" [value]="s.id">
              {{ s.nombre }}
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>business</mat-icon>
        </mat-form-field>
        </div>
        <div class="col-md-4">
      <mat-form-field appearance="outline" class="input-box dias">
        <mat-label><span style="font-size: 10px;font-weight: 500;">Días a solicitar</span></mat-label>

        <input
          matInput
          type="number"
          formControlName="days"
          [max]="available" readonly/>


      </mat-form-field>
      </div>
      <div class="col-md-4">
  @if (form.get('days')?.hasError('required')) {
          <mat-error>Debes ingresar una fecha</mat-error>
        }

        @if (form.get('days')?.hasError('min')) {
          <mat-error>Debes solicitar al menos 1 día</mat-error>
        }

        @if (form.get('days')?.hasError('max') && this.tipodetimeoff == 'Vacations') {
          <mat-error>No puedes solicitar más de {{ available }} días</mat-error>
        }
        </div>
      <!-- <button
        mat-raised-button
        class="btn btn-primary"
        (click)="submitRequest()"
        [disabled]="form.invalid"
      >
        Enviar solicitud
      </button> -->
    </div>
  </div>
    <!-- SELECCIÓN DE FECHAS -->
  <div class="section">
    <h4>FECHAS SELECCIONADAS</h4>

    <mat-form-field class="form-field form-field--full" appearance="outline" style="width: 100%;">
      <ngx-multiple-dates
        [matDatepicker]="picker"
          [matDatepickerFilter]="myFilter"
        placeholder="Seleccionar fechas"
        formControlName="dates"
        (dateChange)="onDatesChange()">
      </ngx-multiple-dates>

      <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker (opened)="onCalendarOpened()"></mat-datepicker>
    </mat-form-field>
  </div>
<!-- Comentario -->
   <div class="section" >
<mat-form-field appearance="fill" style="width: 93%;">
  <mat-label><h4>¿Algún comentario?</h4></mat-label>
  <input matInput placeholder="Puedes agregar comentarios a tu solicitud." formControlName="reqcomments">
  <!-- Optional Hint message -->
  <!-- <mat-hint>Enter a detailed description</mat-hint> -->
</mat-form-field>
  </div>

  <!-- HISTORIAL -->
  <div class="section">
    <h3>HISTORIAL DE SOLICITUDES</h3>

    <div class="history">
      @for (item of history; track $index) {
        <div class="row animate" (click)="timeoffdetails(item)">
          <div class="row-left">
            <mat-icon class="status-icon {{ item.css }}">{{ item.icon }}</mat-icon>
            <!-- {{ item.days }}  -->
            <span>{{item.tipodetimeoff}} {{ item.date }} — {{ item.comments }} </span>
          </div>

          <span class="status-text {{ item.css }}">
            {{ item.status }}
          </span>
        </div>
      }
    </div>
  </div>

</form>

<div class="actions">

      <button
        mat-raised-button
        class="btn btn-primary"
        (click)="submitRequest()"
        [disabled]="form.invalid"
      >
        Enviar solicitud
      </button>
  <button mat-raised-button class="btn btn-cancel" (click)="close()">
    Cerrar
  </button>
</div>
